import { transactionService } from '@/utils/request'

// 关于订单支付和商品下载

// 创建订单-返回支付信息
export function createOrder (data) {
  return transactionService({
    url: 'orderForm/create',
    method: 'post',
    data: data
  })
}

// 继续支付-重新获取支付信息
export function getPayInfo (orderId) {
  return transactionService({
    url: `orderForm/getPayInfo?orderId=${orderId}`,
    method: 'get'
  })
}

/**
 *  发起支付
 * @param {*} params
 * payInfoId 支付信息id
 * payMethod 支付方式
 * @returns
 */
export function createPay (params) {
  return transactionService({
    url: 'pay',
    method: 'post',
    params: params
  })
}

/**
 * 资源详情查看售卖规格
 * @param {*}
 * sellWay: SHARE_STORE/GTY_STORE
 * originId
 * @returns
 */
export function getSellDetail (id) {
  return transactionService({
    url: 'production/detail',
    method: 'get',
    params: {
      sellWay: 'GTY_STORE',
      originId: id
    }
  })
}

// 获取支付结果
export function getPayInfoResult (payInfoId) {
  return transactionService({
    url: `pay/getPayInfo?payInfoId=${payInfoId}`,
    method: 'get'
  })
}

// 图片下载
// 获取下载地址
export function getResourceDownloadUrl (id) {
  return transactionService({
    url: `orderForm/resourceDownloadUrl?productionSpecId=${id}`,
    method: 'get'
  })
}

// 订单管理购买方-列表
export function getBuyList (params) {
  return transactionService({
    url: 'orderForm/buyList',
    method: 'get',
    params: params
  })
}

// 订单管理(卖方)相关接口

// 订单管理-统计
export function getOrderStatistic () {
  return transactionService({
    url: 'orderForm/statistic',
    method: 'get'
  })
}

// 订单管理-统计（超管）
export function getOrderStatisticAdmin (params) {
  return transactionService({
    url: 'orderForm/statisticRoot',
    method: 'get',
    params: params
  })
}

// 订单管理-列表
export function getOrderList (params) {
  return transactionService({
    url: 'orderForm/list',
    method: 'get',
    params: params
  })
}

// 订单管理-列表（超管）
export function getOrderListAdmin (params) {
  return transactionService({
    url: 'orderForm/listRoot',
    method: 'get',
    params: params
  })
}

// 获取物流列表 logistics/allList
export function getLogistics () {
  return transactionService({
    url: 'logistics/allList',
    method: 'get'
  })
}

// 发货/修改
export function deliveryOrder (data) {
  return transactionService({
    url: 'orderForm/delivery',
    method: 'post',
    data: data
  })
}

// 获取店铺列表
export function getAccountSelectList (params) {
  return transactionService({
    url: 'account/selectList',
    params: params
  })
}

// 获取订单信息
export function getOrderInfo (orderId) {
  return transactionService({
    url: `orderForm/getOrderInfo?orderId=${orderId}`,
    method: 'get'
  })
}
